import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import useThemeRender from "../../theme/useThemeRender";
import "./FritoForumDetailPage.css";
import ViewSummary from "../ViewSummary/ViewSummary";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../constant/apiUrl";
import { getAPI, postAPI } from "../../API/ApiService";
import { useSelector, useDispatch } from "react-redux";
import { showErrorToast } from "../../utils/Toast/toast";
import {
  clearFritoImages,
  setFritoImage,
} from "../../slices/fritoForumPageSlice";
import fetchAndCacheImage from "../../utils/fetchandCatchImages";
import Loading from "../../utils/Loader";
import { handleShare } from "../../utils/function";

import BackToFunction from "../Curator/Components/BackToFunction";
import ForumSummaryCard from "./ForumSummaryCard";
import ForumAssociatedContent from "./ForumAssociatedContent";
function FritoForumDetailPage({
  showBackButton = true,
  previewData,
  enabled = true,
  cardButtonDisable,
  forumId,
}) {
  const location = useLocation([]);
  const { id } = useParams();
  const forumCardData = location.state;
  const [data, setData] = useState();
  const documentData = data?.documents || [];
  const videoData = data?.videos || [];
  const linksData = data?.links || [];
  const [loading, setLoading] = useState(true);
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [thumbnailFileId, setThumbnailFileId] = useState(null);
  const navigate = useNavigate();
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);
  const { favourite } = useSelector((store) => store.internalPage);
  const [fetch, setFetch] = useState(false);
  const dispatch = useDispatch();

  const handleMoveBack = () => {
    navigate("/frito-forum-main-page");
  };

  const backgroundColorLayer1 = useThemeRender("backgroundColorLayer1");

  const handleLike = async () => {
    if (enabled) {
      if (isLiked) {
        const data = {
          id: forumCardData?.id,
          likes: false,
          dislikes: false,
        };
        try {
          const response = await postAPI(
            `${BASE_URL}/forum/save-forum-metrics`,
            data
          );
          if (response.status === 200) {
            setIsLiked(false); // Remove dislike
            setFetch(!fetch);
          }
        } catch {}
      } else {
        const newData = {
          id: forumCardData?.id,
          likes: true,
          dislikes: false,
        };
        try {
          const response = await postAPI(
            `${BASE_URL}/forum/save-forum-metrics`,
            newData
          );
          if (response?.status === 200) {
            console.log(response, "------response--------");
            setIsLiked(true); // Set like
            setIsDisliked(false); // Remove dislike (toggle logic)
            setFetch(!fetch);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleDislike = async () => {
    if (enabled) {
      if (isDisliked) {
        const data = {
          id: forumCardData?.id,
          likes: false,
          dislikes: false,
        };
        try {
          const response = await postAPI(
            `${BASE_URL}/forum/save-forum-metrics`,
            data
          );
          if (response.status === 200) {
            console.log(response, "--dislikedResponse----------");
            setIsDisliked(false); // Remove dislike

            setFetch(!fetch);
          }
        } catch {}
      } else {
        const newData = {
          id: forumCardData?.id,
          likes: false,
          dislikes: true,
        };
        try {
          const response = await postAPI(
            `${BASE_URL}/forum/save-forum-metrics`,
            newData
          );
          if (response.status === 200) {
            setIsDisliked(true); // Set dislike
            setIsLiked(false); // Remove like (toggle logic)
            setFetch(!fetch);
          }
          if (response?.status === 400) {
            showErrorToast(response?.message);
          }
        } catch (error) {
          console.log(error, "-----err-------");
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (forumId) {
          setData(previewData);
          setLoading(false);
        } else {
          const response = await getAPI(
            `${BASE_URL}/forum/find-by-forum-id/${id}`
          );
          if (response?.status === 200) {
            dispatch(clearFritoImages());

            const thumbId = response.data?.response?.thumbnailFileId;
            if (thumbId) {
              setThumbnailFileId(thumbId); // Set separately for second useEffect
            }

            setData(response?.data?.response);
            setIsLiked(response?.data?.response?.liked);
            setIsDisliked(response?.data?.response?.disliked);
          }
        }
      } catch (err) {
        showErrorToast(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, favourite, dispatch, forumCardData, fetch]);
  const Share = () => {
    if (enabled) {
      handleShare(location);
    }
  };

  if (loading) return <Loading />;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        background: backgroundColorLayer1,
        padding: {
          xs: "0px",
          sm: " 0px 30px",
        },
      }}
    >
      {showBackButton && (
        <BackToFunction
          label={"Back to Frito forum"}
          handleBack={handleMoveBack}
        />
      )}
      <ForumSummaryCard
        isLiked={isLiked}
        isDisliked={isDisliked}
        onLike={handleLike}
        onDislike={handleDislike}
        onShare={Share}
        data={data}
        enabled={enabled}
      />
      <ForumAssociatedContent
        videoData={videoData}
        documentData={documentData}
        linksData={linksData}
        cardButtonDisable={cardButtonDisable}
      />
      {viewSummaryDrawer && <ViewSummary />}
    </Box>
  );
}

export default FritoForumDetailPage;
